
import { Component, Vue } from "vue-property-decorator";
import { getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { SpringFRewardRecordAPI } from "@/common/api/operationManage/springFDataStatistic";
import { excuteDownloadExport2Excel } from "@/common/xlsx";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { shareConfirmOptions } from "@/common/config";

export const pageApiList = getPageAPIs(SpringFRewardRecordAPI);
const defaultSearchVenuePageOption = {
  page: 1,
  limit: 10,
  isRearchBottom: false,
};
const defaultForm = {
  // phone:'',
  // type:null,
  // reward_name:'',
  time: [],
};
@Component({})
export default class SpringFRewardRecord extends Vue {
  constructor() {
    super();
    this.deepLoopUtil = new DeepLoop();
    this.classApi = new SpringFRewardRecordAPI();
    this.form = { ...this.deepLoopUtil.deepCopy(defaultForm) };
  }
  private classApi: any;

  private form: any = {};
  private deepLoopUtil: any = {};
  private downloadExcelLoading: boolean = false;
  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  // 用户字段名 文案对应关系
  private userExcelList2ch: any = {
    stat_date: "日期",
    draw_user: "抽签人数",
    share_num: "分享次数",
    assistance_num: "成功助力人数",

    invitation_num: "活动拉新",
    pusheng_num: "普胜合成数量",
    exchange_hour_coupon_num: "平台券兑换数量",

    exchange_hour_coupon_rate: "平台券兑换率",
    little_gold_num: "小金合成数量",
    exchange_member_pole_num: "会员杆兑换数量",
    exchange_member_pole_rate: "会员杆兑换率",
    daikin_gold_num: "大金合成数量",
    exchange_senior_member_pole_num: "高级会员杆兑换数量",
    exchange_senior_member_pole_rate: "高级会员杆兑换率",
  };
  // 用户Excel 表头的先后顺序
  private userExcelSortList: string[] = [
    "stat_date",
    "draw_user",
    "share_num",
    "assistance_num",

    "invitation_num",
    "pusheng_num",
    "exchange_hour_coupon_num",

    "exchange_hour_coupon_rate",
    "little_gold_num",
    "exchange_member_pole_num",
    "exchange_member_pole_rate",
    "daikin_gold_num",
    "exchange_senior_member_pole_num",
    "exchange_senior_member_pole_rate",
  ];

  private activated(): void {
    this.getTable();
  }

  private getTable(): void {
    this.classApi.getList(
      {
        ...this.getSpringFRewardRecordParams(),
      },
      (res: any) => {
        this.tableData = res.data.list;
        this.tablePage.totalCount = res.data.count;
      }
    );
  }

  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };
    this.search();
  }

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;
    this.getTable();
  }
  // 点击导出excel 表格
  private handleDownloadExcel() {
    const params = this.getSpringFRewardRecordParams("exportExcel");
    if (params === null) {
      return false;
    }
    this.downloadExcelLoading = true;
    this.classApi.exportList(
      params,
      (res: any) => {
        const { start_date, end_date } = params;
        const timeDuration =
          start_date && end_date ? `${start_date}到${end_date}` : "";
        const filename = `2026暑假活动数据统计 ${timeDuration}.xlsx`;
        const { data } = res;

        const { list: originList } = data;
        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              // item.type =  this.statusObject[item.type]
              return item;
            })
          : [];

        if (newList.length > 0) {
          const userExcelSortList = this.userExcelSortList;

          const userExcelList2ch = this.userExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            userExcelSortList,
            userExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }
  private getSpringFRewardRecordParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const {
      // phone, // 手机号
      // reward_name,

      time,
    } = form;

    const { pageNo, pageSize } = tablePage;

    const outerParams: any = {};

    // if (phone) {
    //   outerParams.phone = phone;
    // }

    // if (reward_name) {
    //   outerParams.reward_name = reward_name;
    // }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;
      outerParams.start_date = startDate;
      outerParams.end_date = endDate;
    }

    if (
      mode == "exportExcel" &&
      !(outerParams.start_date && outerParams.end_date)
    ) {
      this.$message.error("请选择时段导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;
    }

    return outerParams;
  }
}
